import { render } from "./TravelSausageGroup.vue?vue&type=template&id=446a23a7"
import script from "./TravelSausageGroup.vue?vue&type=script&lang=js"
export * from "./TravelSausageGroup.vue?vue&type=script&lang=js"

import "./TravelSausageGroup.vue?vue&type=style&index=0&id=446a23a7&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__